const actions = {
  SET_STATE: 'sessionrecording/SET_STATE',
  LOAD_DATA: 'forms/LOAD_DATA',
}

export default actions
